import React, { useState, useEffect } from "react";
import { format } from "date-fns";
import { formatInTimeZone } from "date-fns-tz";
import { ro } from "date-fns/locale";
import { Muhurta } from "../utils/muhurtasCalculator";
import CalendarSaveButton from "./CalendarSaveButton";

interface MuhurtasListProps {
  muhurtas: Muhurta[];
  selectedTimezone?: string;
}

const MuhurtasList: React.FC<MuhurtasListProps> = ({
  muhurtas,
  selectedTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone,
}) => {
  const [currentTime, setCurrentTime] = useState(new Date());

  // Update current time every second
  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(new Date());
    }, 10000);

    return () => clearInterval(intervalId);
  }, []);
  const formatTime = (date: Date) => {
    return formatInTimeZone(date, selectedTimezone, "HH:mm");
  };

  // Get date range for display
  const dateRangeStr =
    muhurtas.length > 0
      ? `${format(muhurtas[0].startTime, "d MMMM", { locale: ro })} - ${format(
          muhurtas[muhurtas.length - 1].endTime,
          "d MMMM",
          { locale: ro },
        )}`
      : "";

  // Separate day and night muhurtas
  const dayMuhurtas = muhurtas.slice(0, 15);
  const nightMuhurtas = muhurtas.slice(15, 30);

  // Check if a muhurta is current
  const isCurrentMuhurta = (muhurta: Muhurta): boolean => {
    const now = currentTime.getTime();
    return (
      now >= muhurta.startTime.getTime() && now < muhurta.endTime.getTime()
    );
  };

  return (
    <div className="muhurtas-list">
      <h3>Muhurte ale zilei ({dateRangeStr})</h3>
      <p className="muhurta-info">
        Muhurtele sunt unități de timp în astrologia vedică, fiecare având
        calități specifice. Ziua este împărțită în 30 de muhurte (15 ziua și 15
        noaptea).
      </p>
      <div className="muhurtas-container">
        <div className="day-muhurtas">
          <h4>Ziuă (Răsărit - Apus) </h4>
          <ul>
            {dayMuhurtas.map((muhurta, index) => (
              <li
                key={index}
                className={`muhurta-item ${muhurta.isAuspicious ? "auspicious" : "inauspicious"} ${isCurrentMuhurta(muhurta) ? "current-interval" : ""}`}
              >
                <div className="muhurta-header">
                  <span className="muhurta-time">
                    {formatTime(muhurta.startTime)} -{" "}
                    {formatTime(muhurta.endTime)}
                  </span>
                  <span className="muhurta-name">
                    {muhurta.romanianName}
                    <span className="muhurta-quality">
                      {muhurta.isAuspicious ? " (Favorabil)" : " (Nefavorabil)"}
                    </span>
                  </span>
                </div>
                <div className="muhurta-description">
                  {muhurta.romanianDescription}
                  <div className="muhurta-actions">
                    <CalendarSaveButton
                      event={{
                        title: `Muhurta: ${muhurta.romanianName}`,
                        description: `${muhurta.romanianDescription}\n${muhurta.isAuspicious ? "Favorabil" : "Nefavorabil"}`,
                        startTime: muhurta.startTime,
                        endTime: muhurta.endTime,
                      }}
                      buttonClass="right-calendar-icon"
                      showIcon={false}
                    >
                      <img
                        src="/images/apple-calendar-icon.png"
                        alt="Calendar"
                        width="16"
                        height="16"
                      />
                    </CalendarSaveButton>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
        <div className="night-muhurtas">
          <h4>Noapte (Apus - Răsărit) </h4>
          <ul>
            {nightMuhurtas.map((muhurta, index) => (
              <li
                key={index}
                className={`muhurta-item ${muhurta.isAuspicious ? "auspicious" : "inauspicious"} ${isCurrentMuhurta(muhurta) ? "current-interval" : ""}`}
              >
                <div className="muhurta-header">
                  <span className="muhurta-time">
                    {formatTime(muhurta.startTime)} -{" "}
                    {formatTime(muhurta.endTime)}
                  </span>
                  <span className="muhurta-name">
                    {muhurta.romanianName}
                    <span className="muhurta-quality">
                      {muhurta.isAuspicious ? " (Favorabil)" : " (Nefavorabil)"}
                    </span>
                  </span>
                </div>
                <div className="muhurta-description">
                  {muhurta.romanianDescription}
                  <div className="muhurta-actions">
                    <CalendarSaveButton
                      event={{
                        title: `Muhurta: ${muhurta.romanianName}`,
                        description: `${muhurta.romanianDescription}\n${muhurta.isAuspicious ? "Favorabil" : "Nefavorabil"}`,
                        startTime: muhurta.startTime,
                        endTime: muhurta.endTime,
                      }}
                      buttonClass="right-calendar-icon"
                      showIcon={false}
                    >
                      <img
                        src="/images/apple-calendar-icon.png"
                        alt="Calendar"
                        width="16"
                        height="16"
                      />
                    </CalendarSaveButton>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default MuhurtasList;
